import React, { useEffect, useState } from 'react';
import './styles.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

import Header from './components/Header';
// import Nav from './components/Nav';
import Forms from './pages/Forms';
import Eventtickets from './pages/Eventtickets';
import Report from './pages/Report';
import Collegeactivities from './pages/Collegeactivities';
import Members from './pages/Members';
import Settings from './pages/Settings';
import Login from './pages/Login';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    const token = Cookies.get('ec_auth_token') || Cookies.get('token');
    setIsLoggedIn(!!token); // Convert to boolean: true if token exists
  }, []);

  if (isLoggedIn === null) {
    return <div>Loading...</div>; // Optional loading screen
  }

  const userCollege = Cookies.get('college') || 'main';
  const isAuthenticated = Cookies.get('ec_auth_token') || Cookies.get('token');

  return (
    <BrowserRouter>
      {!isLoggedIn ? (
        <Login onLogin={() => setIsLoggedIn(true)} />
      ) : (
        <>
          <Header />
          <div className="main-container">
            {/* <Nav /> */}
            <div className="page-container">
              <Routes>
                <Route path="/" element={<Forms />} />
                <Route path="/forms" element={<Forms />} />
                <Route path="/eventtickets" element={<Eventtickets />} />
                <Route path="/report" element={<Report />} />
                <Route 
                  path="/collegeactivities" 
                  element={
                    userCollege === 'main' ? (
                      <Collegeactivities />
                    ) : (
                      <Navigate to="/forms" replace /> // Kick them back to Forms if they try to cheat
                    )
                  } 
                />
                <Route path="/members" element={<Members />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/login" element={<Forms/>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </div>
        </>
      )}
    </BrowserRouter>
  );
}

export default App;